import { render, staticRenderFns } from "./RelatorioPedidoDeCompraGeralView.vue?vue&type=template&id=31bb976b&scoped=true"
import script from "./RelatorioPedidoDeCompraGeralView.vue?vue&type=script&lang=js"
export * from "./RelatorioPedidoDeCompraGeralView.vue?vue&type=script&lang=js"
import style0 from "./RelatorioPedidoDeCompraGeralView.vue?vue&type=style&index=0&id=31bb976b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31bb976b",
  null
  
)

export default component.exports